var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClimbing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 28.3,
    cy: 45,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7,104.4c2.8,0,5.1-2.3,5.1-5.1V80.8l9.4-9.4L56,93.2l16.4-16.4L50.6,55.1l20.9-20.9l5.8,5.8h18l28.2,28.2H90.5 c-1.4,0-2.7,0.6-3.6,1.5L59.7,96.9c2.3,2.3,5.2,3.4,8.2,3.4h29.6l20.3,20.3c1.5,1.5,3.8,1.9,5.7,1.1v10.9l11.4,11.4h3.8l-12.6-12.6 V67.1L96.3,37.3h-18L48.7,7.7H29.9L22.2,0h-3.8l10.4,10.4h18.8l16.5,16.5L16,75.1c-1,1-1.5,2.3-1.5,3.6v20.6 C14.5,102.1,16.8,104.4,19.7,104.4z M123.5,111.8l-20.2-20.3c0,0,0,0,0,0c-1-1-2.3-1.5-3.6-1.5H81.1l11.5-11.5h30.8L123.5,111.8 L123.5,111.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimbing);
export default __webpack_public_path__ + "static/media/climbing.e041e44a7f203fa424f5ebac4fc437d5.svg";
export { ForwardRef as ReactComponent };